import { SearchX } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useSegmentPaths } from "../hooks/useSegmentPaths";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import EmptyState from "@/components/ui/v2/empty-state";

export function SegmentNotFound() {
  const { t } = useTranslation();
  const paths = useSegmentPaths();

  return (
    <ModernPageLayout>
      <EmptyState
        icon={SearchX}
        title={t("admin.segments.builder.notFound.title")}
        description={t("admin.segments.builder.notFound.description")}
        action={{
          label: t("common.backTo", { entity: t("common.segments") }),
          href: paths.overview,
        }}
      />
    </ModernPageLayout>
  );
}
